import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { CalendarIcon, PencilIcon } from "@heroicons/react/24/solid";
import dayjs from "dayjs";
import moment from "moment";

import { useAtom } from "jotai";
import { gbState } from "../../../../components/shared/GlobalState";

const RecentPostComponent = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const [{ errorLogApi, placeHolderText, user }] = useAtom(gbState);

  const getDataFromServer = () => {
    let userToken = localStorage.getItem("token");
    let urlLink = `${process.env.REACT_APP_API_URL}/post/${user.church_id}`;
    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        const oldData = response.data.posts;
        const updatedData = oldData
          .map((data) => ({
            ...data,
            id: data._id,
            title: data.title,
            description: data.description,
            file_type: data.file_type,
            upload_file: data.upload_file,
            likes: 0,
          }))
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setData(updatedData);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  useEffect(() => {
    getDataFromServer();
  }, []);

  return (
    <div>
      <div className="space-y-4">
        {data.slice(0, 3).map((post, index) => (
          <div key={post.id || index} className="pb-2 border-b last:border-b-0">
            <div className="font-medium text-gray-800">{post.title}</div>
            <div className="flex items-center text-sm text-gray-500">
              <CalendarIcon className="w-4 h-4 mr-1" />
              {moment(post.createdAt).format("MMMM D, YYYY")}
            </div>
          </div>
        ))}
      </div>
      <a
        onClick={() => {
          navigate("/admin/timeline");
        }}
        className="inline-flex items-center mt-4 text-blue-600 cursor-pointer hover:text-blue-800"
      >
        View All My Posts
        <PencilIcon className="w-4 h-4 ml-1" />
      </a>
    </div>
  );
};

export default RecentPostComponent;
